import { render, staticRenderFns } from "./nav-menu-serget.vue?vue&type=template&id=4efd38cb&"
import script from "./nav-menu-serget.vue?vue&type=script&lang=js&"
export * from "./nav-menu-serget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports